import { Col, Container, Row } from "react-bootstrap";
import PageTitleBar from "../../Components/Site/PageTitleBar";

const PrivacyPolicy = () => {
  return (
    <>
      <PageTitleBar
        title="Privacy Policy"
        subTitle="Last Updated on 27th August 2025"
      />

      <section className="section-pad">
        <Container>
          <Row>
            <Col>
              <div className="cms-content">
                <h2>Introduction</h2>
                <p>At Joyfullminds ("Joyfullminds," "we," "our," or "us"), located at 980, Adarsh Colony, Sarna, Pathankot, Punjab – 145025, we deeply value the trust you place in us and are committed to safeguarding your personal information in accordance with applicable laws. Collecting and processing your personal data is essential for delivering our services effectively.</p>
                <p>We prioritize your privacy and ensure that your information is gathered, used, processed, and shared strictly as outlined in this Privacy Policy. This Privacy Policy should be read in conjunction with our Terms of Service and takes effect once you, as a user ("User" or "You"), acknowledge your acceptance by selecting the designated checkbox.</p>
                <p>We retain the right to modify this Privacy Policy at any time. Any updates will take effect as soon as they are published on the Website/Application. For significant changes or updates, we will seek your consent. By continuing to use our services, you acknowledge your responsibility to regularly review the latest version of the Privacy Policy provided by Joyfullminds.</p>

                <h2>A. Definitions</h2>
                <dl>
                  <dt>A.A "Affiliate"</dt>
                  <dd>Any entity, organization, or individual associated with Joyfullminds through direct partnership, ownership, control, or business relationship as specified in Clause H.A of this Privacy Policy.</dd>

                  <dt>A.B "Application"</dt>
                  <dd>Digital platforms owned and operated by Joyfullminds, including but not limited to its website and mobile application.</dd>

                  <dt>A.C "Consultation Information"</dt>
                  <dd>Details shared by a user during counseling or advisory sessions, including personal experiences, mental health concerns, and medical history.</dd>

                  <dt>A.D "Consent Form"</dt>
                  <dd>A formal document that outlines the terms under which a user agrees to share their personal information.</dd>

                  <dt>A.E "Experts"</dt>
                  <dd>Qualified professionals like psychiatrists, counselors, and therapists who provide mental health support through Joyfullminds.</dd>

                  <dt>A.F "Grievance Officer"</dt>
                  <dd>Individual responsible for addressing and resolving user complaints and concerns regarding privacy and service issues.</dd>

                  <dt>A.G "IP (Intellectual Property)"</dt>
                  <dd>All proprietary assets owned by Joyfullminds including trademarks, copyrights, patents, software, and content.</dd>

                  <dt>A.H "Linked Sites"</dt>
                  <dd>Third-party websites or digital platforms referenced or integrated with Joyfullminds’ services.</dd>

                  <dt>A.I "Minor"</dt>
                  <dd>Individual below the age of 18 years.</dd>

                  <dt>A.J "Personal Information"</dt>
                  <dd>Data used to identify an individual directly or indirectly, including name, contact, DOB, health records, etc.</dd>

                  <dt>A.K "Services"</dt>
                  <dd>Mental health, wellness, and counseling-related offerings provided by Joyfullminds.</dd>

                  <dt>A.L "Terms of Service"</dt>
                  <dd>Official document outlining rules and conditions governing the use of Joyfullminds’ services.</dd>

                  <dt>A.M "User Account"</dt>
                  <dd>Personalized digital profile created by a user to access Joyfullminds’ services.</dd>

                  <dt>A.N "User Credentials"</dt>
                  <dd>Authentication details such as username and password to access the User Account.</dd>

                  <dt>A.O "User Data"</dt>
                  <dd>Information collected from users during service use, excluding sensitive Consultation Information.</dd>

                  <dt>A.P "Website"</dt>
                  <dd>Joyfullminds’ official online platform for accessing services and information.</dd>
                </dl>

                <h2>2. Use of Services by Minors</h2>
                <p>The use of our services by a minor is limited to accessing the Applications and using it with a signed Consent Form. Rest of the provisions regarding data collection stands.</p>
                <p>We do not intentionally gather or collect Personal Information from children under the age of 13 and minors. Use of Applications and Services by such individuals must be preceded by legal guardian consent. In abusive circumstances, we reserve the right to remove such data upon scrutiny. Contact the Grievance Officer in Clause 12 if you suspect data from a minor has been collected improperly.</p>

                <h2>3. What Information Do We Collect?</h2>
                <h3>C.A Information We Collect</h3>
                <ul>
                  <li><strong>C.A.1:</strong> Details during registration like username, password, contact info, age, gender, etc.</li>
                  <li><strong>C.A.2:</strong> Automatically collected data such as IP, location, device, browser details, etc.</li>
                  <li><strong>C.A.3:</strong> User activity data and behavior on the platform.</li>
                  <li><strong>C.A.4:</strong> Publicly shared information in forums or group chats.</li>
                  <li><strong>C.A.5:</strong> Payment-related details handled by third-party gateways.</li>
                  <li><strong>C.A.6:</strong> Consultation session records with user consent.</li>
                  <li><strong>C.A.7:</strong> Any additional personal details shared voluntarily.</li>
                </ul>

                <h3>C.B Your Choice in Sharing Information</h3>
                <p>Providing information is essential for service access. Declining to share required data may limit service access or features.</p>

                <h2>4. How Do We Collect Your Information?</h2>
                <h3>D.A Methods of Information Collection</h3>
                <ul>
                  <li><strong>D.A.1:</strong> Direct input from users via forms, chats, emails, or usage.</li>
                  <li><strong>D.A.2:</strong> Third-party tools like cookies, web beacons, or login providers.</li>
                  <li><strong>D.A.3:</strong> Shared access through employers, institutions, or partner entities.</li>
                  <li><strong>D.A.4:</strong> Data collected during expert consultations.</li>
                  <li><strong>D.A.5:</strong> Automatically collected technical and behavioral data.</li>
                  <li><strong>D.A.6:</strong> Engagement through social media interactions.</li>
                </ul>

                <h2>5. How Do We Use Your Information?</h2>
                <h3>E.A Purpose of Data Usage</h3>
                <ul>
                  <li><strong>E.A.1:</strong> Delivering services and platform features.</li>
                  <li><strong>E.A.2:</strong> Support and legal compliance.</li>
                  <li><strong>E.A.3:</strong> Personalizing and improving user experience.</li>
                  <li><strong>E.A.4:</strong> Tracking and cookie-based analytics.</li>
                  <li><strong>E.A.5:</strong> Location-based advertising (with consent).</li>
                  <li><strong>E.A.6:</strong> Enhanced navigation and metrics analysis.</li>
                </ul>

                <h2>E.A.7 Analytics &amp; Usage Insights</h2>
                <p>We utilize third-party analytics tools to measure traffic, user engagement, and platform performance. These tools collect non-personal data, such as:</p>
                <ul>
                  <li>Pages visited, browser extensions used, and interaction patterns.</li>
                  <li>Aggregated and anonymized logs, ensuring individual users remain unidentifiable.</li>
                </ul>

                <h2>E.A.8 Facilitating Communication</h2>
                <p>We may use certain information to enable interactions between users on our platform, ensuring seamless communication and engagement.</p>

                <h2>E.A.9 Anonymized Data for Research &amp; Development</h2>
                <p>To enhance our services and contribute to research, we may anonymize personal and consultation information so that individual users cannot be identified. This anonymized data may be shared with partners and combined with broader user insights for analysis and service improvement.</p>

                <h2>6. Why Do We Retain Your Information?</h2>
                <p>We retain your information in accordance with applicable laws to ensure compliance, legal obligations, and smooth service operations. Your personal information, user data, and any other details related to your access and use of our services may be stored for at least seven (7) years from the date you share them with us.</p>
                <p>This retention period allows us to:</p>
                <ul>
                  <li>Meet legal, regulatory, and tax-related obligations.</li>
                  <li>Keep records for potential evidence in case of disputes.</li>
                  <li>Efficiently manage and improve your access to our services.</li>
                </ul>
                <p>Your personal information will be securely stored by us or authorized third-party partners, as detailed in Clause 8.</p>

                <h2>7. How Do We Collect, Protect, and Share Your Consultation Information?</h2>
                <p>To provide our services effectively, you agree to let JoyfullMinds process (including share and transfer) any information you provide during consultations with our experts. This “Consultation Information” is treated with strict confidentiality and is not used for marketing, advertising, or analytics purposes as outlined in Clauses E.A.3 to E.A.8.</p>

                <h3>G.A Who Can Access Your Consultation Information?</h3>
                <ul>
                  <li>Only authorized experts, personnel, and relevant third-party service providers who need access to deliver services can view your Consultation Information.</li>
                  <li>These individuals and entities are required to respect confidentiality and adhere to strict data protection standards.</li>
                </ul>

                <h3>G.B When Do We Share Your Consultation Information?</h3>
                <p>We do not disclose your Consultation Information—either verbally or in writing—unless:</p>
                <ol>
                  <li>You provide explicit consent for such sharing.</li>
                  <li>It is required by law or a regulatory authority.</li>
                  <li>It is necessary for your safety or the safety of others.</li>
                </ol>
                <p>Additionally, if you are claiming health insurance, you consent to sharing your Consultation Information with third-party insurance service providers, as required for processing your claim.</p>

                <h3>G.C Limited Circumstances Where We May Share Your Information:</h3>
                <ul>
                  <li><strong>Urgent Safety Concerns:</strong> If we believe there is an immediate risk to your health, safety, or life, or if someone else is at serious risk, we may share necessary details with appropriate authorities.</li>
                  <li><strong>Legal Compliance:</strong> If required by law, regulation, or a government agency, we may disclose your information to comply with legal or regulatory obligations. If an employer, educational institution, or organization that provides you access to our services requests information for legal or regulatory purposes, we may share details as required.</li>
                </ul>

                <h2>8. Do We Share Your Information?</h2>
                <p>We value your privacy and only share your information when necessary for providing and improving our services. Here’s how and when we may share your data:</p>

                <h3>H.A Sharing with Our Affiliate Companies</h3>
                <p>We may share your personal information (such as data from cookies, log files, and usage details, but excluding Consultation Information) with companies that are legally part of the same corporate group as JoyfullMinds.</p>

                <h3>H.B Sharing with Service Providers &amp; Third Parties</h3>
                <p>Your personal and consultation-related data may also be shared with trusted partners, service providers, and third-party organizations that assist in delivering our services.</p>

                <h3>H.C Third-Party Collaboration for Service Enhancement</h3>
                <p>We may work with external partners who help us operate the platform effectively. This includes analytics, infrastructure support, and customer service solutions.</p>

                <h3>H.D Anonymized Data Sharing</h3>
                <p>When we share data beyond service-related purposes, we remove identifiable details and only share anonymized or aggregated data that cannot be traced back to you.</p>

                <h3>H.E Publicly Shared Content</h3>
                <p>Any information or content you voluntarily post on our platform becomes publicly visible and may be reshared or repurposed by others.</p>

                <h3>H.F Sharing with Employers, Institutions &amp; Authorized Entities</h3>
                <p>We may share anonymized data with them. However, we will not share any personally identifiable information or consultation details unless:</p>
                <ul>
                  <li>It is legally required.</li>
                  <li>You provide explicit consent.</li>
                  <li>It falls under exceptional circumstances mentioned in Clause 7.</li>
                </ul>

                <h3>H.G Legal &amp; Regulatory Disclosures</h3>
                <p>If required by law or regulatory authorities, we may disclose your personal data in compliance with legal obligations.</p>

                <h3>H.H Adherence to Data Protection Laws</h3>
                <p>Whenever we share personal data with third parties, we ensure they comply with data protection laws and follow the same security standards that we uphold.</p>

                <h2>9. How Do We Keep Your Information Secure?</h2>
                <h3>I.A Security Measures &amp; Restricted Access</h3>
                <p>We have adopted technical and organizational security measures to prevent unauthorized access, misuse, or data breaches.</p>

                <h3>I.B Your Role in Maintaining Security</h3>
                <p>Your account security is also in your hands. You must:</p>
                <ul>
                  <li>Keep your password and login credentials confidential.</li>
                  <li>Avoid sharing your User Credentials with anyone.</li>
                  <li>Be cautious while accessing your account on shared or public devices.</li>
                </ul>

                <h2>10. Third-Party Websites</h2>
                <h3>J.A External Links</h3>
                <p>Our platform may include links to external websites ("Linked Sites") operated by third parties. JoyfullMinds is not responsible for the content or practices of these sites.</p>

                <h3>J.B No Endorsement</h3>
                <p>The presence of Linked Sites does not imply endorsement or affiliation with JoyfullMinds.</p>

                <h3>J.C Separate Policies</h3>
                <p>When you visit a Linked Site, you will be subject to its own terms of use and privacy policy. We encourage you to review them before sharing personal information.</p>

                <h2>11. Your Rights Regarding Your Information</h2>
                <h3>K.A Your Rights</h3>
                <p>You have rights regarding how your personal data is handled, including:</p>
                <ul>
                  <li><strong>K.A.1 Right to Access:</strong> Request details about your data, including what we hold and who we share it with.</li>
                  <li><strong>K.A.2 Right to Modify or Delete:</strong> Correct, update, or delete your data if it's inaccurate or outdated.</li>
                  <li><strong>K.A.3 Right to Nominate a Representative:</strong> Designate someone to manage your data rights in the event of your death or incapacity.</li>
                </ul>

                <h3>K.B How to Exercise Your Rights</h3>
                <p>To exercise these rights, email our Grievance Officer (see Clause 12). Note that requesting deletion of essential data may limit our ability to provide services to you.</p>

                <h2>12. Grievance Officer</h2>
                <p>If you have questions, concerns, or grievances, contact our Grievance Officer:</p>
                <ul>
                  <li><strong>Name:</strong> Munish Kanwar</li>
                  <li><strong>Phone Number:</strong> 09999301877</li>
                  <li><strong>Email:</strong> <a href="mailto:munish.kanwar@joyfullminds.com">munish.kanwar@joyfullminds.com</a></li>
                  <li><strong>Postal Address:</strong> #980, Adarsh Colony, Sarna, Pathankot (Punjab) - 145025</li>
                </ul>

                <p>By checking this box, you confirm that you have read, understood, and agree to the processing, collection, storage, disclosure, transfer, and sharing of your personal and consultation data as outlined in our Privacy Policy.</p>
                <p>You also have the right to withdraw your consent at any time by contacting our Grievance Officer via email.</p>

              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PrivacyPolicy;
